var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "c-check_svg__nc-icon-wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#86AE43",
    d: "M24 47C11.317 47 1 36.682 1 24S11.317 1 24 1s23 10.318 23 23-10.317 23-23 23z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M20 34.829L9.172 24 12 21.171l8 8 16-16L38.828 16z"
  }))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCA0OCA0OCI+PGcgY2xhc3M9Im5jLWljb24td3JhcHBlciI+PHBhdGggZmlsbD0iIzg2QUU0MyIgZD0iTTI0LDQ3QzExLjMxNzM4LDQ3LDEsMzYuNjgyMTMsMSwyNFMxMS4zMTczOCwxLDI0LDFzMjMsMTAuMzE3ODcsMjMsMjNTMzYuNjgyNjIsNDcsMjQsNDd6Ii8+IDxwb2x5Z29uIGZpbGw9IiNGRkZGRkYiIHBvaW50cz0iMjAsMzQuODI4NjEgOS4xNzE4OCwyNCAxMiwyMS4xNzEzOSAyMCwyOS4xNzEzOSAzNiwxMy4xNzEzOSAzOC44MjgxMiwxNiAiLz48L2c+PC9zdmc+";
export { SvgCCheck as ReactComponent };